<template>
  <div ref="carousel" class="tarotSlider">
    <div class="carousel-cell tarotSlider__item" v-for="(maj, index) in major" :key="maj.key">
      <div
        class="cardWrapper"
        :data-cardIndex="index"
        data-toggle="modal"
        data-target="#astroModal"
        v-on:click="getTarot(maj.name_short)"
      >
        <div class="tarotCard__face back">
          <img class src="../../assets/mobiscope/imgs/tarot_image/back-card.png" />
        </div>
        <div class="tarotCard__face front">
          <img class :src="maj.image" />
        </div>
      </div>
      <p class="tarotCard__label">{{maj.name}}</p>
    </div>
  </div>
</template>

<script>
import Flickity from "flickity";
// import "flickity/dist/flickity.min.css";
export default {
  data() {
    return {
      flickityOptions: {
        dragThreshold: 50,
        initialIndex: 0,
        prevNextButtons: true,
        pageDots: false,
        wrapAround: true,
        adaptiveHeight: true,
        hash: true,
        percentPosition: false
      },
      stageDragging: false,
    };
  },
  props: ["major", "getTarot"],
  mounted() {
      const flkty = new Flickity(this.$refs.carousel, this.flickityOptions);
      flkty.on("dragStart", function() {
        this.stageDragging = true;
      });
      flkty.on("dragEnd", function() {
        this.stageDragging = false;
      });

      const cardWrapper = document.getElementsByClassName("cardWrapper");
      Array.from(cardWrapper).forEach(function(card) {
        card.addEventListener("click", () => {
          flkty.select(card.getAttribute("data-cardindex"));
        });
      });    
  },
  methods: {}
};
</script>

<style lang= "scss">
.tarotSlider {
  /* height: 480px; */
  .cardWrapper {
    display: block;
    position: relative;
    transform-style: preserve-3d;
    transform: rotateY(180deg) scale(0.9);
    height: 440px;
  }
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  .is-selected .cardWrapper {
    animation: cardFlip 0.275s forwards linear;
  }
}
.tarotCard__label {
  text-align: center;
  margin: 12px 0px;
  display: none;
  font-size: 1.2rem;
}
.tarotSlider__item {
  height: 480px;
}
.tarotCard__face {
  position: absolute;
  backface-visibility: hidden;
  width: 100%;
  height: 100%;
}
.tarotCard__face.back {
  z-index: 4;
  top: 0;
  left: 0;
  transform: rotateY(180deg);
}
.tarotCard__face.front {
  position: relative;
  overflow: hidden;
  border-radius: 30px;
  border: 5px solid #000;
}
.carousel {
  background: #fafafa;
}

@keyframes cardFlip {
  0% {
    transform: rotateZ(0deg) rotateY(180deg);
  }
  50% {
    transform: rotateZ(-10deg) rotateY(90deg);
  }
  100% {
    transform: rotateZ(0deg) rotateY(0deg);
  }
}
.carousel-cell {
  width: 23%;
  /* height: 100%; */
  margin-right: 10px;
  border-radius: 5px;
}

//Responsive styles
@media (max-width: 991px) {
  .carousel-cell.tarotSlider__item {
    width: 100%;
    max-width: 280px;
  }
}
@media (max-width: 479px) {
  .carousel-cell.tarotSlider__item {
    max-width: 320px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/mobiscope/TarotSlider.vue